import * as React from 'react';
import { Box, TextAction, UtilityText } from '@leagueplatform/genesis-core';
import { Link } from 'react-router-dom';
import type {
  StatusReportTableRowLinkableText,
  StatusReportTableRowStatus,
} from '../status-report-table-row.types';
import { getStatusReportCellCss } from './get-status-report-cell-css';

/**
 * Renders a linkable-text table cell for the resolved column value.
 * Shows a link when `value.path` exists, otherwise renders plain text.
 */
export const StatusReportLinkableTextCell = ({
  value,
  rowStatus,
}: {
  value: StatusReportTableRowLinkableText;
  rowStatus?: StatusReportTableRowStatus;
}) => {
  if (value.path) {
    return (
      <Box as="td" css={getStatusReportCellCss('linkableText')}>
        <TextAction
          as={Link}
          to={value.path}
          target="_blank"
          rel="noopener noreferrer"
          indicator={value.indicator}
          css={{
            fontWeight: '$normal',
            textDecoration: value.underlined ? 'underline' : undefined,
            '&:hover': {
              textDecoration: value.underlined ? 'underline' : undefined,
            },
            display: 'inline-flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            verticalAlign: 'top',
          }}
        >
          {value.label}
        </TextAction>
      </Box>
    );
  }

  return (
    <Box as="td" css={getStatusReportCellCss('linkableText')}>
      <UtilityText
        emphasis={rowStatus === 'loading' ? 'subtle' : undefined}
        css={{
          color: rowStatus === 'error' ? '$onSurfaceTextCritical' : undefined,
          display: 'inline-flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          verticalAlign: 'top',
        }}
      >
        {value.label}
      </UtilityText>
    </Box>
  );
};
